import { Box } from '@chakra-ui/react';
import { DefaultLayout } from '../../_layout/DefaultLayout';
import { BookingPaymentsReportTabs } from './BookingPaymentsReportTabs';

const BookingPaymentsReport = (): JSX.Element => (
  <DefaultLayout>
    <Box flex="1" borderRadius={8} bg="white" p="8">
      <BookingPaymentsReportTabs />
    </Box>
  </DefaultLayout>
);

export default BookingPaymentsReport;
